export function Footer() {
  return (
    <footer className="md:px-8 md:py-0 border-t z-20 bg-background">
      <div className="container mx-auto px-4 py-2 md:py-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-balance text-center text-sm leading-loose text-muted-foreground md:text-left">
            © {new Date().getFullYear()} <a href="https://cocorograph.co/" target="_blank" rel="noopener noreferrer" className="font-medium underline underline-offset-4">cocorograph Inc.</a> All rights reserved.
          </div>
          <div className="flex space-x-4 mb-1 md:mb-0">
            {/* <Link href="/privacy" className="text-sm transition-colors hover:text-foreground/80 text-foreground/60">
              プライバシーポリシー
            </Link>
            <Link href="/terms" className="text-sm transition-colors hover:text-foreground/80 text-foreground/60">
              利用規約
            </Link> */}
          </div>
          <div className="flex space-x-4">
            {/* <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="Facebook">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="Twitter">
              <Twitter className="h-5 w-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="Instagram">
              <Instagram className="h-5 w-5" />
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  )
}
